import { render, staticRenderFns } from "./addRentAd.vue?vue&type=template&id=ff687004&scoped=true&"
import script from "./addRentAd.vue?vue&type=script&lang=js&"
export * from "./addRentAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff687004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff687004')) {
      api.createRecord('ff687004', component.options)
    } else {
      api.reload('ff687004', component.options)
    }
    module.hot.accept("./addRentAd.vue?vue&type=template&id=ff687004&scoped=true&", function () {
      api.rerender('ff687004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/addRentAd.vue"
export default component.exports